import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const RegPaymentProofModal = ({ title, onClose, modalData, submitData }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    setValue,
    trigger,
  } = useForm({
    defaultValues: {
      studentFirstRegistrationId: modalData?.id || 0,
      receiptName: "",
      base64Url: "",
      createdBy: localStorage.getItem("userId"),
    },
  });

  const [isLoading, setIsLoading] = useState(false);
  const [imageName, setImageName] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    // Reset form when modalData changes
    reset({
      studentFirstRegistrationId: modalData?.id || 0,
      receiptName: modalData?.receiptFilePath
        ? modalData.receiptFilePath.split("/").pop()
        : "",
      base64Url: "",
      createdBy: localStorage.getItem("userId"),
    });
    setImageName(
      modalData?.receiptFilePath
        ? modalData.receiptFilePath.split("/").pop()
        : ""
    );
    setPreviewUrl(
      modalData?.receiptFilePath
        ? `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${modalData.receiptFilePath}`
        : null
    );
  }, [modalData, reset]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageName(file.name);
      setValue("receiptName", file.name, { shouldValidate: false });

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Url = reader.result.split(",")[1];
        setValue("base64Url", base64Url, { shouldValidate: false });
        setPreviewUrl(reader.result);
        setTimeout(() => {
          trigger(["receiptName", "base64Url"]);
        }, 0);
      };
      reader.readAsDataURL(file);
    } else {
      setImageName(
        modalData?.receiptFilePath
          ? modalData.receiptFilePath.split("/").pop()
          : ""
      );
      setPreviewUrl(
        modalData?.receiptFilePath
          ? `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${modalData.receiptFilePath}`
          : null
      );
      setValue(
        "receiptName",
        modalData?.receiptFilePath
          ? modalData.receiptFilePath.split("/").pop()
          : "",
        {
          shouldValidate: true,
        }
      );
      setValue("base64Url", "", { shouldValidate: true });
      trigger(["receiptName", "base64Url"]);
    }
  };

  const saveData = async (formData) => {
    setIsLoading(true);
    try {
      await submitData(formData);
      reset();
      setImageName("");
      setPreviewUrl(null);
    } catch (error) {
      console.error("Error processing payment:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">{title}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(saveData)}>
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label">
                      Image Preview
                      <span className="text-danger fs-9">*</span>
                    </label>
                    <div className="image-uploader-wrapper-2 d-flex flex-column align-items-center">
                      <div className="image-preview d-flex justify-content-center align-items-center flex-shrink-0 mb-2 mt-1">
                        {previewUrl ? (
                          <img src={previewUrl} alt="Preview" />
                        ) : (
                          <div>
                            <span className="fas fa-image fs-3 text-light"></span>
                          </div>
                        )}
                      </div>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={handleFileChange}
                      />
                      <input
                        type="hidden"
                        {...register("receiptName", {
                          required: "This field is required.",
                        })}
                      />
                    </div>
                    {errors.receiptName && (
                      <small className="text-danger">
                        {errors.receiptName.message}
                      </small>
                    )}
                  </div>
                  <div className="col-12">
                    <div className="d-flex gap-2 justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary"
                        disabled={isLoading || !imageName}
                      >
                        {isLoading ? "Saving..." : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default RegPaymentProofModal;
